import {
  Avatar,
  HStack,
  Icon,
  Image,
  SimpleGrid,
  StackProps,
  Text,
  VStack,
} from "@chakra-ui/react";
import { RiMapPin2Line } from "@remixicon/react";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { SupplierList } from "../../constants/Supplier";
import { useBgHover, useDarkWhiteColor } from "../../themes/colors";
import { explodeString, splitCityName } from "../../utils/helperFunction";

interface Props extends StackProps {
  data: SupplierList | undefined;
}

export const SupplierCard = ({ data, ...rest }: Props) => {
  const bgBnw = useDarkWhiteColor();
  const bgHover = useBgHover();
  const [column, setColumn] = useState<number>(3);
  const navigate = useNavigate();

  useEffect(() => {
    if (data?.productImages) {
      if (data?.productImages.length === 3) {
        setColumn(3);
      } else if (data?.productImages.length === 2) {
        setColumn(2);
      } else if (data?.productImages.length === 1) {
        setColumn(1);
      } else if (data?.productImages.length > 3) {
        setColumn(3);
      }
    }
  }, [data?.productImages, data?.productImages.length]);

  const goToDetailSupplier = () => {
    navigate(`/reseller/search/supplier/${data?.id}`);
  };

  return (
    <VStack
      p={2}
      gap={2}
      bg={bgBnw}
      align={"stretch"}
      cursor={"pointer"}
      borderRadius={"md"}
      _hover={{ bg: bgHover }}
      onClick={goToDetailSupplier}
      {...rest}
    >
      <HStack gap={2} alignItems={"start"}>
        <Avatar
          name={data?.name || ""}
          src={
            data?.logo ? `${process.env.REACT_APP_MEDIA_URL}${data?.logo}` : ""
          }
          size={"sm"}
        />

        <VStack gap={0} align={"stretch"}>
          <Text textStyle={"b-sm-sb"} noOfLines={1} textOverflow={"ellipsis"}>
            {data?.name || "Supplier BisnisLink"}
          </Text>

          {data?.city && (
            <HStack gap={1}>
              <Icon
                as={RiMapPin2Line}
                fontSize={[10, null, 12]}
                opacity={0.6}
              />

              <Text
                fontSize={[10, null, 12]}
                variant={"secondary"}
                noOfLines={1}
                textOverflow={"ellipsis"}
              >
                {splitCityName(explodeString(data?.city).nama)}
              </Text>
            </HStack>
          )}
        </VStack>
      </HStack>

      <SimpleGrid w={"100%"} columns={column} gap={1}>
        {data?.productImages.slice(0, 3).map((item, i) => (
          <Image
            className="ratio-9-16"
            key={i}
            w={"100%"}
            h={"100%"}
            minH={"75px"}
            maxH={"75px"}
            fallbackSrc="/assets/svg/illustration_empty.svg"
            src={item ? `${process.env.REACT_APP_MEDIA_URL}${item}` : ""}
            objectFit={"cover"}
            borderRadius={"md"}
          />
        ))}
      </SimpleGrid>
    </VStack>
  );
};
